import { Box, Button, Modal, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { makeToasterErrorHandler } from "../../common/http/makeToasterErrorHandler";
import { FinancialEntryInterface } from "../../common/interfaces";
import { usePageToast } from "../../hooks/usePageToast";
import api from "../../services/api";
import PageToaster from "../toaster/PageToaster";

interface Props {
  open: boolean;
  onClose: () => void;
  onCanceled: () => void;
  entry: FinancialEntryInterface | null;
}

const FinancialEntryCancelModal: React.FC<Props> = ({ open, onClose, onCanceled, entry }) => {
  const [reason, setReason] = useState("");

  const containerId = "toaster-financial-cancel-modal";
  const { autoSuccess, autoError } = usePageToast(containerId, true);
  const handleHttpError = makeToasterErrorHandler(autoError);

  useEffect(() => {
    if (open) setReason("");
  }, [open]);

  const handleSubmit = async () => {
    if (!entry) return;
    if (!reason.trim()) {
      autoError("Informe o motivo do cancelamento.");
      return;
    }
    try {
      await api.post(`/financial/entries/${entry.financial_entry_id}/cancel`, {
        reason: reason.trim()
      });
      autoSuccess("Lançamento cancelado.");
      onCanceled();
      onClose();
    } catch (error) {
      handleHttpError(error);
    }
  };

  return (
    <>
      <PageToaster containerId={containerId} />
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            border: "1px solid var(--border-strong)",
            p: 3,
            borderRadius: 2,
            boxShadow: 3,
            width: 380
          }}
        >
          <h2>Cancelar lançamento</h2>
          <p style={{ color: "var(--text-muted)" }}>{entry?.description}</p>

          <TextField
            fullWidth
            label="Motivo do cancelamento"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            margin="normal"
            multiline
            minRows={2}
            required
          />

          <Box sx={{ mt: 3, textAlign: "right" }}>
            <Button onClick={onClose} sx={{ mr: 1 }}>
              Voltar
            </Button>
            <Button variant="contained" color="error" onClick={handleSubmit}>
              Confirmar cancelamento
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default FinancialEntryCancelModal;
